import { FolderUp, Upload } from 'lucide-react';

/** Canonical glyph for upload-files actions — do not hand-pick upload glyphs at call sites. */
export const UPLOAD_ICON = Upload;

/** Canonical glyph for upload-folder actions — do not hand-pick upload glyphs at call sites. */
export const UPLOAD_FOLDER_ICON = FolderUp;
